export default __webpack_public_path__ + "static/945-81eed6923f2506ee87ecd9b66112a75d.gif";